import { Action } from 'redux';

import { PublishedConnectionTableExtractsRefreshNow } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface PublishedConnectionTableExtractsRefreshNowAction extends Action {
  readonly selectedContent: IContentInfo[];
}

export function publishedConnectionTableExtractsRefreshNow(selectedContent: IContentInfo[]): PublishedConnectionTableExtractsRefreshNowAction {
  return {
    type: PublishedConnectionTableExtractsRefreshNow,
    selectedContent
  };
}
